// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fda8393f","239":"a316acc1","453":"1e1b3c10","455":"3ee2fa02"}[chunkId] + ".chunk.js";
};